import React, { useEffect } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container } from "react-bootstrap";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { MasterWise, resetMasterWise } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import Chart from "../../../../components/Charts/Chart";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";


export default function TotalMeter({ selectedProduction, selectedAccount }) {

  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { MasterWisedata } = useSelector((state) => state.GreyDashboardSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  useEffect(() => {
    dispatch(resetMasterWise())
    dispatch(MasterWise({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])


  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    MasterWisedata?.OpInwMeter?.[0]?.FAcYear
  );

  const tableData = (MasterWisedata?.OpInwMeter || []).map(
    (row, index, arr) => ({
      srNumber: (index + 1),
      ProductionGroupMstName: row.ProductionGroupMstName,
      OpInwMeter: row.OpInwMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "OpInwMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];

  const getYearFromRange = (range) => {
    if (!range) return "";

    const parts = range.split("-");

    if (parts.length === 2) {
      const startYear = parts[0].split("/").pop();
      const endYear = parts[1].split("/").pop().slice(-2);
      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const uniqueYears = [
    ...new Set(
      (MasterWisedata?.OpInwMeterMonth || []).map((el) =>
        getYearFromRange(el.AcYear)
      )
    ),
  ];

  const groupedData = {};

  (MasterWisedata?.OpInwMeterMonth || []).forEach((row) => {
    const group = row.ProductionGroupMstName;
    const year = getYearFromRange(row.AcYear);

    if (!groupedData[group]) {
      groupedData[group] = {
        ProductionGroupMstName: group,
        TotalOpInwMeter: 0, // 👈 total initialize
      };
    }

    groupedData[group][year] = row.OpInwMeter;

    // 👇 total add karte jao
    groupedData[group].TotalOpInwMeter += row.OpInwMeter || 0;
  });

  const tableData1 = Object.values(groupedData).map((item, index) => ({
    // srNumber: index + 1,
    ...item,
  }));

  const columns1 = [
    { label: "Charts", key: "charts" },
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Production Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },

    // 👇 Total Meter column
    {
      label: "Total Meter",
      key: "TotalOpInwMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },

    // 👇 Dynamic Year Columns
    ...uniqueYears.map((year) => ({
      label: year,
      key: year,
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    })),
  ];

  const chartData1 = (MasterWisedata?.OpInwMeter || []).map((row) => ({
    month: row.ProductionGroupMstName,
    value: row.OpInwMeter
  }));


  const isNoData =
    !MasterWisedata?.OpInwMeter ||
    MasterWisedata?.OpInwMeter.length === 0;

  if (MasterWisedata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }


  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row
        className="justify-content-center"
        style={{ margin: 0, padding: 0 }}
      >

        <Col xl={12} className=' p-0'>
          <div>
            <Chart data={chartData1} title="Groupwise Opening Meter" />
          </div>
        </Col>
        <Col xl={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"

                }}
              >
                GROUPWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

        <Col xl={12} className="pt-4" style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,

              }}
            >
              <h2
                className="text-xl font-semibold tracking-wide"
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"

                }}
              >
                YEARWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}